import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Slider from '@mui/material/Slider';
import { useHighlightedScore } from './HighlightedScoreContext';
import PercentageBox from './PercentageBox';

const MIN = 0;
const MAX = 100;

const SetThresholdRange: React.FC = () => {
  const { lowThreshold, highThreshold, setLowThreshold, setHighThreshold } = useHighlightedScore();
  const value: [number, number] = [lowThreshold, highThreshold];

  const handleChange = (_event: Event, newValue: number | number[]) => {
    if (Array.isArray(newValue) && newValue.length === 2) {
      const [low, high] = newValue as [number, number];
      // Clamp into bounds and keep ordering low <= high
      const nextLow = Math.max(MIN, Math.min(low, MAX));
      const nextHigh = Math.max(nextLow, Math.min(high, MAX));
      setLowThreshold(nextLow);
      setHighThreshold(nextHigh);
    }
  };

  return (
    <Box sx={{ width: 360,p:2 }}>
      <Typography id="threshold-range-slider" gutterBottom>
        Score Thresholds (Low / High)
      </Typography>
      <Slider
        value={value}
        onChange={handleChange}
        valueLabelDisplay="auto"
        valueLabelFormat={(value) => `${value}%`}
        aria-labelledby="threshold-range-slider"
        min={MIN}
        max={MAX}
      />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
          <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>Low: <PercentageBox correctPercentage={lowThreshold} /></Typography>

          <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>High: <PercentageBox correctPercentage={highThreshold} /></Typography>

      </Box>
    </Box>
  );
};

export default SetThresholdRange;
